/* cyber-monday.js — countdown, filtro de fichas, FAQ y precio mínimo del sticky.
   Vanilla, sin dependencias. Idempotente: varias secciones pueden incluirlo. */
(function () {
  if (window.__cmInit) return;
  window.__cmInit = true;

  var pad = function (n) {
    return String(Math.floor(n)).padStart(2, "0");
  };

  /* ---------- Countdown ----------
     <div data-cm-countdown="2026-10-07T23:59:59-03:00">
       <span data-cm-unit="d|h|m|s">00</span> ...
       <span data-cm-ended hidden>Oferta finalizada</span>
     </div>
     Al llegar a 0: oculta [data-cm-live], muestra [data-cm-ended]. */
  function tick() {
    var now = Date.now();
    document.querySelectorAll("[data-cm-countdown]").forEach(function (el) {
      var end = Date.parse(el.getAttribute("data-cm-countdown"));
      if (isNaN(end)) return;
      var diff = Math.max(0, end - now) / 1000;
      var parts = {
        d: pad(diff / 86400),
        h: pad((diff % 86400) / 3600),
        m: pad((diff % 3600) / 60),
        s: pad(diff % 60)
      };
      el.querySelectorAll("[data-cm-unit]").forEach(function (u) {
        var next = parts[u.getAttribute("data-cm-unit")];
        if (u.textContent === next) return;
        u.textContent = next;
        // los números grandes del hero hacen un pequeño "tic" al cambiar
        if (u.classList.contains("cm-countdown__num")) {
          u.classList.remove("cm-tick");
          void u.offsetWidth;
          u.classList.add("cm-tick");
        }
      });
      var finished = diff <= 0;
      el.querySelectorAll("[data-cm-live]").forEach(function (n) {
        n.hidden = finished;
      });
      el.querySelectorAll("[data-cm-ended]").forEach(function (n) {
        n.hidden = !finished;
      });
    });
  }

  /* ---------- Selector de necesidad (Wi-Fi / chip / internet) ----------
     Pulsar una opción filtra las fichas y muestra una recomendación de una línea.
     Pulsarla de nuevo la quita y vuelven todas. */
  document.addEventListener("click", function (event) {
    var btn = event.target.closest("[data-cm-filter]");
    if (!btn) return;
    var root = btn.closest("[data-cm-grid]");
    if (!root) return;
    var wasOn = btn.getAttribute("aria-pressed") === "true";
    var value = wasOn ? "all" : btn.getAttribute("data-cm-filter");
    root.querySelectorAll("[data-cm-filter]").forEach(function (b) {
      b.setAttribute("aria-pressed", !wasOn && b === btn ? "true" : "false");
    });
    var reco = root.querySelector("[data-cm-reco]");
    if (reco) {
      var text = wasOn ? "" : btn.getAttribute("data-cm-reco-text") || "";
      reco.textContent = text;
      reco.hidden = !text;
    }
    root.querySelectorAll("[data-cm-cat]").forEach(function (card) {
      card.hidden = value !== "all" && card.getAttribute("data-cm-cat") !== value;
    });
    // la barra fija pasa al producto de la necesidad elegida (o al predeterminado)
    document.dispatchEvent(new CustomEvent("cm:need-change", { detail: { need: value } }));
    // las fichas que quedan visibles vuelven a entrar con la animación
    root.querySelectorAll("[data-cm-cat]:not([hidden])").forEach(function (card, i) {
      if (!card.classList.contains("cm-reveal")) return;
      card.style.setProperty("--cm-delay", i * 80 + "ms");
      card.classList.remove("is-in");
      void card.offsetWidth;
      card.classList.add("is-in");
    });
  });

  /* ---------- Barra fija: producto según la necesidad ---------- */
  document.addEventListener("cm:need-change", function (event) {
    var need = (event.detail && event.detail.need) || "all";
    document.querySelectorAll("[data-cm-sticky]").forEach(function (bar) {
      var items = bar.querySelectorAll("[data-cm-sticky-item]");
      if (items.length < 2) return;
      var pick = items[0];
      if (need !== "all") {
        for (var i = 0; i < items.length; i++) {
          if (items[i].getAttribute("data-cm-sticky-item") === need) {
            pick = items[i];
            break;
          }
        }
      }
      items.forEach(function (it) {
        it.hidden = it !== pick;
      });
    });
  });

  /* ---------- Carrusel de reseñas (móvil): una tarjeta por vez, puntos y flechas ---------- */
  function carouselIndex(list) {
    var slides = list.children;
    var center = list.scrollLeft + list.clientWidth / 2;
    var best = 0;
    var bestDist = Infinity;
    for (var i = 0; i < slides.length; i++) {
      var mid = slides[i].offsetLeft + slides[i].offsetWidth / 2;
      var d = Math.abs(mid - center);
      if (d < bestDist) {
        bestDist = d;
        best = i;
      }
    }
    return best;
  }

  function carouselGo(list, index) {
    var slides = list.children;
    if (!slides.length) return;
    var i = Math.max(0, Math.min(slides.length - 1, index));
    var smooth = !(window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches);
    var target = slides[i].offsetLeft - (list.clientWidth - slides[i].offsetWidth) / 2;
    list.scrollTo({ left: Math.max(0, target), behavior: smooth ? "smooth" : "auto" });
  }

  function carouselSync(wrap) {
    var list = wrap.querySelector("[data-cm-carousel]");
    var dots = wrap.querySelector("[data-cm-carousel-dots]");
    if (!list || !dots) return;
    if (dots.children.length !== list.children.length) {
      dots.innerHTML = "";
      for (var i = 0; i < list.children.length; i++) {
        var dot = document.createElement("button");
        dot.type = "button";
        dot.className = "cm-carousel__dot";
        dot.setAttribute("aria-label", "Ir a la reseña " + (i + 1));
        dot.setAttribute("data-cm-carousel-dot", String(i));
        dots.appendChild(dot);
      }
    }
    var current = carouselIndex(list);
    Array.prototype.forEach.call(dots.children, function (d, i) {
      d.setAttribute("aria-current", i === current ? "true" : "false");
    });
  }

  document.addEventListener("click", function (event) {
    var wrap = event.target.closest(".cm-reviews__wrap");
    if (!wrap) return;
    var list = wrap.querySelector("[data-cm-carousel]");
    if (!list) return;
    if (event.target.closest("[data-cm-carousel-prev]")) carouselGo(list, carouselIndex(list) - 1);
    else if (event.target.closest("[data-cm-carousel-next]")) carouselGo(list, carouselIndex(list) + 1);
    else {
      var dot = event.target.closest("[data-cm-carousel-dot]");
      if (dot) carouselGo(list, parseInt(dot.getAttribute("data-cm-carousel-dot"), 10));
    }
  });

  document.addEventListener("keydown", function (event) {
    var list = event.target.closest && event.target.closest("[data-cm-carousel]");
    if (!list || event.target !== list) return;
    if (event.key === "ArrowRight") {
      event.preventDefault();
      carouselGo(list, carouselIndex(list) + 1);
    } else if (event.key === "ArrowLeft") {
      event.preventDefault();
      carouselGo(list, carouselIndex(list) - 1);
    }
  });

  function setupCarousels() {
    document.querySelectorAll(".cm-reviews__wrap").forEach(function (wrap) {
      carouselSync(wrap);
      var list = wrap.querySelector("[data-cm-carousel]");
      if (!list || list.__cmCarousel) return;
      list.__cmCarousel = true;
      var ticking = false;
      list.addEventListener(
        "scroll",
        function () {
          if (ticking) return;
          ticking = true;
          window.requestAnimationFrame(function () {
            ticking = false;
            carouselSync(wrap);
          });
        },
        { passive: true }
      );
    });
  }

  /* ---------- FAQ: una abierta a la vez ---------- */
  document.addEventListener(
    "toggle",
    function (event) {
      var item = event.target;
      if (!item.matches || !item.matches(".cm-faq__item") || !item.open) return;
      var list = item.closest(".cm-faq__list");
      if (!list) return;
      list.querySelectorAll(".cm-faq__item[open]").forEach(function (other) {
        if (other !== item) other.open = false;
      });
    },
    true
  );

  /* ---------- Sticky: "Cyber desde $X" = precio más bajo de la grilla ---------- */
  function setMinPrice() {
    var targets = document.querySelectorAll("[data-cm-min-price]");
    if (!targets.length) return;
    var best = null;
    document.querySelectorAll("[data-cm-price]").forEach(function (card) {
      var value = parseInt(card.getAttribute("data-cm-price"), 10);
      if (!isNaN(value) && (best === null || value < best.value)) {
        best = { value: value, text: card.getAttribute("data-cm-price-text") };
      }
    });
    targets.forEach(function (t) {
      if (best) t.textContent = best.text;
      var wrap = t.closest("[data-cm-min-wrap]");
      if (wrap) wrap.hidden = !best;
    });
  }

  /* ---------- Pestañas (2b): cambia ficha + barra fija, resetea cantidad ---------- */
  function resetQty(panel) {
    var input = panel.querySelector("input[name=quantity]");
    var val = panel.querySelector("[data-cm-qty-val]");
    if (input) input.value = "1";
    if (val) val.textContent = "1";
  }

  document.addEventListener("click", function (event) {
    var tab = event.target.closest("[data-cm-tab]");
    if (!tab) return;
    var root = tab.closest("[data-cm-tabs]");
    if (!root) return;
    var id = tab.getAttribute("data-cm-tab");
    root.querySelectorAll("[data-cm-tab]").forEach(function (t) {
      t.setAttribute("aria-selected", t === tab ? "true" : "false");
    });
    root.querySelectorAll("[data-cm-panel]").forEach(function (p) {
      var on = p.getAttribute("data-cm-panel") === id;
      p.hidden = !on;
      if (on) resetQty(p);
    });
    document.querySelectorAll("[data-cm-bar]").forEach(function (b) {
      b.hidden = b.getAttribute("data-cm-bar") !== id;
    });
  });

  /* ---------- Galería: miniaturas cambian la foto principal ---------- */
  document.addEventListener("click", function (event) {
    var thumb = event.target.closest("[data-cm-thumb]");
    if (!thumb) return;
    var panel = thumb.closest("[data-cm-panel]");
    if (!panel) return;
    var idx = thumb.getAttribute("data-cm-thumb");
    panel.querySelectorAll("[data-cm-thumb]").forEach(function (t) {
      t.setAttribute("aria-current", t === thumb ? "true" : "false");
    });
    panel.querySelectorAll("[data-cm-img]").forEach(function (img) {
      img.hidden = img.getAttribute("data-cm-img") !== idx;
    });
  });

  /* ---------- Cantidad 1–9 ---------- */
  document.addEventListener("click", function (event) {
    var btn = event.target.closest("[data-cm-qty]");
    if (!btn) return;
    var panel = btn.closest("[data-cm-panel]");
    if (!panel) return;
    var input = panel.querySelector("input[name=quantity]");
    var val = panel.querySelector("[data-cm-qty-val]");
    var step = parseInt(btn.getAttribute("data-cm-qty"), 10);
    var next = Math.min(9, Math.max(1, (parseInt(input.value, 10) || 1) + step));
    input.value = String(next);
    val.textContent = String(next);
  });

  // La barra fija agrega con la cantidad elegida en la ficha del mismo producto
  document.addEventListener(
    "submit",
    function (event) {
      var form = event.target;
      if (!form.matches || !form.matches("[data-cm-bar-form]")) return;
      var panel = document.querySelector('[data-cm-panel="' + form.getAttribute("data-cm-bar-form") + '"]');
      var qty = panel && panel.querySelector("input[name=quantity]");
      if (qty) form.elements.quantity.value = qty.value;
    },
    true
  );

  /* ---------- Animación de entrada al hacer scroll ----------
     Solo se oculta algo si el navegador soporta IntersectionObserver, el
     usuario no pidió menos movimiento y no estamos en el editor de temas. */
  var REVEAL = [
    ".cm-grid__head",
    ".cm-faq .cm-h2",
    ".cm-compare .cm-h2",
    ".cm-more__head",
    ".cm-tile",
    ".cm-trust__cell",
    ".cm-card",
    ".cm-mcard",
    ".cm-tabs__row",
    ".cm-compare__table",
    ".cm-reviews__sum",
    ".cm-review",
    ".cm-reviews__apps",
    ".cm-faq__item",
    ".cm-pay__inner"
  ].join(",");
  var revealIO = null;

  function setupReveal() {
    var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    var inEditor = window.Shopify && window.Shopify.designMode;
    if (!("IntersectionObserver" in window) || reduce || inEditor) return;

    if (!revealIO) {
      revealIO = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            entry.target.classList.add("is-in");
            revealIO.unobserve(entry.target);
          });
        },
        { rootMargin: "0px 0px -8% 0px", threshold: 0.08 }
      );
    }

    document.querySelectorAll(REVEAL).forEach(function (el) {
      if (el.__cmReveal) return;
      el.__cmReveal = true;
      // visible en el primer pantallazo (o fuera de uso): aparece al instante, sin animación
      var r = el.getBoundingClientRect();
      if (el.offsetParent === null || r.top < window.innerHeight) return;
      // escalonado entre hermanos (máx. 5 pasos de 80ms)
      var peers = Array.prototype.filter.call(el.parentElement ? el.parentElement.children : [], function (c) {
        return c.matches(REVEAL);
      });
      el.style.setProperty("--cm-delay", Math.min(peers.indexOf(el), 5) * 80 + "ms");
      el.classList.add("cm-reveal");
      revealIO.observe(el);
    });
    document.documentElement.classList.add("cm-js");
  }

  /* ---------- Scroll a ancla: lleva al primer destino VISIBLE de la lista ----------
     <a data-cm-scroll="#ofertas,#ofertas-pc"> — en móvil se ve la grilla y en desktop
     las pestañas, así que se elige el que esté mostrándose (nunca uno oculto). */
  document.addEventListener("click", function (event) {
    var link = event.target.closest("[data-cm-scroll]");
    if (!link) return;
    var ids = link.getAttribute("data-cm-scroll").split(",");
    var target = null;
    ids.forEach(function (raw) {
      var sel = raw.trim();
      if (target || sel.charAt(0) !== "#" || sel.length < 2) return;
      var el = document.getElementById(sel.slice(1));
      if (el && el.offsetParent !== null) target = el;
    });
    if (!target) return;
    event.preventDefault();
    var margin = parseFloat(window.getComputedStyle(target).scrollMarginTop) || 0;
    var top = target.getBoundingClientRect().top + window.pageYOffset - margin;
    var smooth = !(window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches);
    window.scrollTo({ top: Math.max(0, top), behavior: smooth ? "smooth" : "auto" });
  });

  /* ---------- Barra fija superior: aparece cuando el hero ya quedó atrás ----------
     Vale para móvil y desktop (y también dentro del editor de temas, para que no tape la imagen).
     Usa el hero que esté visible (hay uno para móvil y otro para desktop) y la posición real
     de la barra: aparece cuando el borde inferior del hero ya pasó por debajo del header. */
  var barTicking = false;

  function barTopOffset() {
    var bars = document.querySelectorAll(".cm-sticky__bar, .cm-pdpbar");
    for (var i = 0; i < bars.length; i++) {
      var style = window.getComputedStyle(bars[i]);
      if (style.display !== "none") {
        var top = parseFloat(style.top);
        if (!isNaN(top)) return top;
      }
    }
    return 80;
  }



  function onScrollBar() {
    if (barTicking) return;
    barTicking = true;
    window.requestAnimationFrame(updateBar);
  }

  window.addEventListener("scroll", onScrollBar, { passive: true });
  window.addEventListener("resize", onScrollBar);

  function init() {
    setupReveal();
    setupCarousels();
    tick();
    setMinPrice();
    updateBar();
  }

  setInterval(tick, 1000);
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
  // Editor de temas: re-evaluar al agregar/editar secciones
  document.addEventListener("shopify:section:load", init);
})();
